function Footer() {

    return ( 

        <div class="hstack gap-3 my-5 mx-5" id="informazioni">
        <div class="bg-light border">Orari d'apertura: lunedì-sabato 8:30/13:00</div>
        <div class="bg-light border ms-auto">Via Eugenio Criscione Lupis n°169, Ragusa, Italia </div>
        <div class="vr"></div>
        <div class="bg-light border">P.IVA: 01276530886 Codice Aziendale: 006RG817</div>
        <div> Credits cheese icon to <a href="https://icons8.it"> icons8.it </a> </div>
        </div>

        

        

    );

}

export default Footer;